<style src='@/resources/styles/home.css' scoped></style>
<style src='@/resources/styles/keyframes.css' scoped></style>

<template>
  <main class='view-home'>
    <div class='container'>
      <div class='inner'>
        <!--<div class='spirit-guide'></div>-->
        <div class='intro'>
          <h1 class='lead' >Never settle for a name without .com again</h1>
          <p class='blurb' style="max-width: 70%">
            Naminus generates names you'll love, by analyzing your 🙂 😍 👎 votes and learning your tastes.
          </p>
        </div>
        
        <div class='naminate'>
          <div class='form'>
            <input type='text'
                   id='seeds'
                   ref="input"
                   class='word-input bordered'
                   placeholder='Enter some words, e.g food, pasta, etc.'
                   v-model.trim="seeds"
                   v-on:input="updateStatus"
                   v-on:keyup.enter="generate"
                   autofocus
            />
            <button class='generate-button'
                    :disabled="isValid !== true"
                    v-on:click="generate">Go</button>
          </div>

          <div class="status" v-bind:class="statusClass">{{status}}</div>
        </div>
      </div>

    <!--<div class='steps columns'>
        <div class='row'>
          <div class='step one-third'>
            <div class='icon'>
              <span class='quotes'></span>
            </div>
            <h3 class='caption'>
              <span class='number'>1.</span> Enter words
            </h3>
            <div class='details'>E.g. Popcorn, nachos, salsa, movies, kissing,  etc.</div>
          </div>
          <div class='step one-third'>
            <div class='icon'>
              <img src='@/resources/images/icons/grin-hearts.png' alt=':)'>
            </div>
            <h3 class='caption'>
              <span class='number'>2.</span> Rate results
            </h3>
            <div class='details'>Help Naminator learn your tastes by rating the results.</div>
          </div>
          <div class='step one-third'>
            <div class='icon'>
              <img src='@/resources/images/icons/refresh-outline.svg' alt=''>
            </div>
            <h3 class='caption'>
              <span class='number'>3.</span> Generate again
            </h3>
            <div class='details'>The results will get better each time you run Naminator.</div>
          </div>
        </div>
      </div>-->
    </div><!--/container-->
      
    <section class='onboard'>
      <!--<div class='scroll-down-pointer slideUpAndDown'></div>-->
      <div class='inner'>
        <div class='columns'>
          <div class='one-whole part'>
            <div class='one-half'>
              <div class='caption'>
                <h2><span class='stride'>1</span>Enter some keywords</h2>
              </div>
            </div>
            <div class='one-half'>
              <video autoplay loop muted class='demo' src='@/resources/videos/Enter-Some-Words.mp4'></video>
            </div>
          </div>
          <div class='one-whole part'>
            <div class='one-half'>
              <div class='caption'>
                <h2><span class='stride'>2</span>Tell Naminus which names you like</h2>
              </div>
            </div>
            <div class='one-half'>
              <video autoplay loop muted class='demo' src='@/resources/videos/Review-Some-Names.mp4'></video>
            </div>
          </div>
          <div class='one-whole part'>
            <div class='one-half'>
              <div class='caption'>
                <h2><span class='stride'>3</span>Get better names with each 🙂+😍</h2>
              </div>
            </div>
            <div class='one-half'>
              [video coming soon]
            </div>
          </div>
        </div>
      </div>
      <div class='naminate'>
        <button 
          class='button generate-button generate-names'
          v-on:click="generate"
        >Generate names</button>
      </div>
    </section>
  </main>
</template>

<script>
  import Quotes from "../../services/Quotes"
  import States from "../../States"
  import {mapActions} from "vuex";


  export default {
    name: 'HomeView',
    data: function() {
      return {
        seeds: "",
        wordCount: 0,
        quotes: new Quotes(),
        status: "",
        statusClass: "",
        isValid: false,
        errors: [],
      }
    },

    mounted: function() {
      this.updateStatus();

      //this.$store.getters.api.tokenPromise.then(token => window.console.log("Received final token:", token));
      this.$store.commit("setState", States.HOME);
      this.pageLoaded(this.$route);
    },

    methods: {
      ...mapActions(['pageLoaded']),

      removeInvalidChars: function() {
        //If doesn't contain any invalid chars, skip without replacing
        if (/^[a-zA-Z, ]+$/i.test(this.seeds))
          return;

        this.seeds = this.seeds.replace(/[^a-zA-Z, ]+/ig, '');
      },

      getIndividualWords: function(){
        return this.seeds.split(/[ ,]+/)
                .map(s => s.trim() )
                .filter(s => s.length > 0);
      },

      updateStatus: function() {
        this.removeInvalidChars();
        if (this.seeds.length <= 0) {
          this.showHint();
          return;
        }

        this.errors = [];
        const words = this.getIndividualWords();
        const validWords = [];

        if (words.length > 3) {
          //const extra = words.length - 4;
          this.errors.push("Please enter 3 or fewer words (you entered " + words.length + ")");
          this.showErrors();
          return;
        }

        const lastWordIndex = words.length - 1;
        const minLen = this.$store.getters.minLen;
        const maxLen = this.$store.getters.maxLen;

        for (let i = 0; i < words.length; i++) {
          const word = words[i];
          if (word.length < minLen) {

            if (i < lastWordIndex) //don't show too short if this is the last word, they're probably still typing it
              this.errors.push(word + " is too short - Please enter at least " + minLen + "  character words.");
          }
          else if (word.length > maxLen) {
            const extra = word.length - maxLen;
            this.errors.push(word + " is too long - needs " + extra + " less character(s).")
          }
          else
            validWords.push(word);
        }


        if (this.errors.length > 0) {
          this.showErrors();
          return;
        }

        this.toggleQuote(validWords.length > 0, words);
      },

      showHint: function() {

        //For now, don't show hint so they have less stuff to read.
        //But if they erased all text in the textbox so it ended up blank and this method was called,
        //then just erase anything in the status box.
        this.isValid = false;
        this.status = "";
        this.wordCount = 0; //reset word count so when they start typing, a new quote will be shown.
        //this.statusClass = "hint";
        //this.status = "Each word should be at least 3 letters, at most 15.";
      },


      showErrors: function( ){
        this.isValid = false;
        this.statusClass = "error";
        this.status = this.errors.join("\n");
      },

      toggleQuote: function(valid, individualWords) {
        const newWordCount = individualWords.length;

        if (newWordCount === 0)
        {
          this.wordCount = 0;
          return;
        }

        //New word added, or status changed from error or hint to quote
        if (newWordCount > this.wordCount || this.statusClass !== "quote")
          this.status = this.quotes.nextQuote();

        this.isValid = valid;
        this.statusClass = "quote";
        this.wordCount = newWordCount;
      },

      generate: function () {
          if (! this.isValid) {
              window.console.log("Not valid");
              return;
          }

          const payload = {
            keywords: this.getIndividualWords(),
            router: this.$router,
          };

          this.$store.dispatch("generate", payload);
      },
    }
  }
</script>